import { gql } from "@apollo/client";

export const GET_SALON_SERVICES_GROUPED_BY_CATEGORY = gql`
  query GetSalonServicesGroupedByCategory($salonId: ID!) {
    getSalonServicesGroupedByCategory(salonId: $salonId) {
      category {
        id
        category_name
      }
      services {
        id
        description
        price
        duration
        status
        service {
          id
          service_name
        }
      }
    }
  }
`;